import { CssBaseline, useMediaQuery } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { FeatureFlagIdDarkMode } from 'c1gen/features'
import { C1Theme, C1DarkTheme } from 'c1ui'
import { useFeatureChecker } from 'components/no-ui/capability'
import { FC, ReactNode } from 'react'

interface C1ThemeProviderWithDarkModeProps {
    children: ReactNode
}

export const C1ThemeProviderWithDarkMode: FC<C1ThemeProviderWithDarkModeProps> = ({ children }) => {
    const hasDarkModeFeature = useFeatureChecker(FeatureFlagIdDarkMode)
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)')

    // Use dark theme only if feature flag is enabled AND user prefers dark mode
    const shouldUseDarkTheme = hasDarkModeFeature && prefersDarkMode
    const theme = shouldUseDarkTheme ? C1DarkTheme : C1Theme

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    )
}
